import React from 'react';
import { Link } from 'react-router-dom';

export const TermsPage: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <h1 className="text-3xl font-bold text-gray-900 mb-2">服务条款</h1>
      <p className="text-sm text-gray-500 mb-8">最后更新：2025年4月</p>

      <div className="prose prose-gray max-w-none space-y-6 text-gray-700 leading-relaxed">
        <section>
          <h2 className="text-xl font-semibold text-gray-900 mb-3">1. 服务说明</h2>
          <p>
            AI少儿编程学习平台（以下简称"本平台"）是一个面向青少年的 AI 编程教育服务平台，
            提供在线编程学习、AI 模型训练、项目实践等功能。注册使用本平台即表示您同意遵守以下条款。
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-900 mb-3">2. 账户注册</h2>
          <ul className="list-disc pl-6 space-y-1">
            <li>用户需提供真实、准确的注册信息。</li>
            <li>每位用户仅可注册一个账户，不得转让或出售。</li>
            <li>用户应妥善保管账户密码，因账户保管不善导致的损失由用户自行承担。</li>
            <li>未成年人注册使用本平台，应在监护人同意和指导下进行。</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-900 mb-3">3. 使用规范</h2>
          <p>用户在使用本平台时，不得从事以下行为：</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>发布、传播违法或不良信息。</li>
            <li>上传侵犯他人知识产权的内容。</li>
            <li>利用平台进行恶意攻击或破坏系统安全。</li>
            <li>使用自动化工具批量操作或干扰平台正常运行。</li>
            <li>冒充他人或虚构身份。</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-900 mb-3">4. 知识产权</h2>
          <ul className="list-disc pl-6 space-y-1">
            <li>本平台的教学内容、界面设计、软件代码等受知识产权法保护。</li>
            <li>用户在平台上创作和上传的原创内容，其知识产权归用户所有。</li>
            <li>用户授予本平台非独占的使用许可，以提供和改善服务。</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-900 mb-3">5. 服务变更与中断</h2>
          <p>
            我们有权根据业务需要调整、暂停或终止部分或全部服务，并将尽可能提前通知用户。
            因系统维护、升级等原因导致服务中断，我们不承担由此造成的损失，但会尽力缩短中断时间。
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-900 mb-3">6. 免责声明</h2>
          <ul className="list-disc pl-6 space-y-1">
            <li>本平台提供的 AI 模型训练结果仅供参考和学习使用，不构成专业建议。</li>
            <li>因不可抗力导致的服务中断或数据丢失，我们不承担责任。</li>
            <li>用户因违反本条款而导致的任何损失，由用户自行承担。</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-900 mb-3">7. 账户终止</h2>
          <p>
            如用户违反本服务条款，我们有权暂停或永久终止其账户。
            用户可主动申请注销账户，注销后相关数据将按规定处理。
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-900 mb-3">8. 条款修改</h2>
          <p>
            我们保留修改本服务条款的权利。修改后的条款将在平台上公布，
            继续使用本平台即视为接受修改后的条款。
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-900 mb-3">9. 联系我们</h2>
          <p>
            如您对本服务条款有任何疑问，请通过
            <Link to="/contact" className="text-blue-600 hover:underline"> 联系我们 </Link>
            页面与我们取得联系。
          </p>
        </section>
      </div>
    </div>
  );
};
